import { DefaultQueryParams } from '@frontend/api-utils';
import { ChartClient } from '@frontend/chart/api';
import { SpotFillRateMetricChart, hasChartData } from '@frontend/chart/components';
import { Chart, ChartBinSize, ChartQueryParam } from '@frontend/chart/types';
import { Application } from '@frontend/functionality/types';
import { useEffect, useState } from 'react';

import { getLast60DaysChartRange } from '../last-30-days-chart-range';

export const useLast60DaysPudoSpotFillRateMetricChart = (accountId: string) => {
    const [data, setData] = useState<Chart | undefined>(undefined);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!accountId) {
            setIsLoading(false);
            return;
        }

        let cancelled = false;
        setIsLoading(true);

        const { after, before } = getLast60DaysChartRange();

        ChartClient.fetchChartData(accountId, SpotFillRateMetricChart.definition, {
            [DefaultQueryParams.AFTER]: after,
            [DefaultQueryParams.BEFORE]: before,
            [ChartQueryParam.BIN_SIZE]: ChartBinSize.MONTH,
            [ChartQueryParam.APPLICATION]: Application.PUDO
        })
            .then((chart) => {
                if (!cancelled) {
                    setData(chart);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setData(undefined);
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setIsLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [accountId]);

    return {
        data,
        isLoading,
        hasData: hasChartData(data)
    };
};
